var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "save-button",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _c("heart-unfilled", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.score || _vm.score == 0,
            expression: "!score || score == 0"
          }
        ],
        class: _vm.classes
      }),
      _vm._v(" "),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.score == 1,
            expression: "score == 1"
          }
        ],
        class: _vm.classes,
        attrs: { src: _vm.imageUrl("like_fill.svg") }
      }),
      _vm._v(" "),
      _c("heart-animated", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.animating,
            expression: "animating"
          }
        ],
        staticClass: "icon-heart-animating",
        class: _vm.classes
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44590e6e", { render: render, staticRenderFns: staticRenderFns })
  }
}